import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

const initialState: any = {
  orderList: [],
  selectedOrderInfo: null,
  selectedBarcodeData: null,
  orderLogs: [],
  orderConfirmationStatus: "pending",
};

const ecwOrderSlice = createSlice({
  name: "ecwOrders",
  initialState,
  reducers: {
    setEcwOrderList: (state, action: PayloadAction<any>) => {
      state.orderList = action.payload;
    },
    setEcwSelectedOrderInfo: (state, action: PayloadAction<any>) => {
      state.selectedOrderInfo = action.payload;
    },
    setEcwOrderLogs: (state, action: PayloadAction<any>) => {
      state.orderLogs = action.payload;
    },
    setEcwSelectedBarcodeData: (state, action: PayloadAction<any>) => {
      state.selectedBarcodeData = action.payload;
    },
    setEcwOrderConfirmationStatus: (state, action: PayloadAction<"pending" | "confirmed" | "cancelled">) => {
      state.orderConfirmationStatus = action.payload;
    },
  },
});
export const {
  setEcwOrderList,
  setEcwSelectedOrderInfo,
  setEcwOrderLogs,
  setEcwSelectedBarcodeData,
  setEcwOrderConfirmationStatus,
} = ecwOrderSlice.actions;
export default ecwOrderSlice.reducer;
export const ecwOrderList = (state: RootState) => state.ecwOrders.orderList;
export const ecwSelectedOrderInfo = (state: RootState) => state.ecwOrders.selectedOrderInfo;
export const ecwOrderLogs = (state: RootState) => state.ecwOrders.orderLogs;
export const ecwSelectedBarcodeData = (state: RootState) => state.ecwOrders.selectedBarcodeData;
export const ecwOrderConfirmationStatus = (state: RootState): "pending" | "confirmed" | "cancelled" =>
  state.ecwOrders.orderConfirmationStatus ?? "pending";